import { DateTime } from "luxon"

// SPEC-045 K1-grace / SPEC-053 R20: is the analysis inside the one-day MANUAL grace window?
// Its EARLIEST task start must fall in [yesterday 00:00, today 00:00) in the team timezone.
// Mirrors backend common.started_yesterday exactly (get_lock_boundary(tz) → today 00:00;
// yesterday = that minus one day; inside iff yesterday <= earliest < today). Returns false when
// the analysis started 2+ days ago, is a manually-locked future analysis (earliest >= today
// 00:00), or has no dated tasks. The grace is manual-only and covers exactly two actions: adding
// a straggler sample (K1, "Add Samples") and unplanning an unfinished sample (R20, both unplan
// entry points) — automation (Fill-In/IAP) and move-off/delete/unlock never consult this.
// SPEC-046 (F1): reads the authoritative `analysis.earliestTaskStart` (serialized by the backend
// as the min task start over ALL tasks, SPEC-047) instead of scanning the date-windowed
// `state.analysisTasks` store, which only holds the tasks of the currently fetched schedule
// window and therefore mis-judged analyses whose earliest task lay outside it.
export function isWithinOneDayLockGrace(analysis, teamTimeZone) {
  if (!analysis?.earliestTaskStart) return false
  const today = DateTime.now().setZone(teamTimeZone).startOf("day")
  const yesterday = today.minus({ days: 1 })
  const earliest = DateTime.fromISO(analysis.earliestTaskStart)
  return earliest >= yesterday && earliest < today
}

// SPEC-068 R21 / SPEC-066 V4 (#4166): how many CALENDAR days a past task on an executed analysis
// (DONE/FAILED samples) stays manually movable. Mirrors backend common.MANUAL_TASK_MOVE_GRACE_DAYS —
// a fixed system rule, not a team option.
export const MANUAL_TASK_MOVE_GRACE_DAYS = 3

// Is this task's CURRENT start too old to be moved by hand any more? Mirrors backend
// common.task_beyond_move_grace exactly: frozen iff start < today 00:00 (team tz) − 3 days, so on
// Thursday the Monday task is still movable, on Friday it is not. Measured on the TASK's own start
// (never the analysis' earliest task, which only drives the hard lock). A task with no start is
// never frozen. SINGLE-task moves only — the multi-select bulk move keeps R17's today-00:00 rule
// (see isTaskStartInPast in ScheduleElementHour), and the server refuses accordingly.
export function isTaskBeyondMoveGrace(taskStart, teamTimeZone) {
  if (!taskStart) return false
  const boundary = DateTime.now().setZone(teamTimeZone).startOf("day").minus({ days: MANUAL_TASK_MOVE_GRACE_DAYS })
  return DateTime.fromISO(taskStart) < boundary
}
